import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";

export interface ContactInformation {
  id?: number;
  customer: number;
  first_name: string;
  family_name: string;
  email: string;
  position: string;
  contact_type: string;
  contact_email_types: string;
  reminder: boolean;
  account: number;
  reminder_scope: string;
  countries: any;
}

export default class ContactInformationService {
  private httpClient = makeHttpClient();
  private contactUrl = env.customerUrl + "contact/";
  getAll(customer_id: number) {
    if (customer_id) {
      return _unwrapAxiosResponse(
        this.httpClient.get<ContactInformation>(
          `${this.contactUrl}?id=${customer_id}`
        )
      );
    }
    return _unwrapAxiosResponse(
      this.httpClient.get<ContactInformation>(this.contactUrl)
    );
  }

  create(form: any, customer_id: any) {
    const data: ContactInformation = {
      customer: customer_id,
      first_name: form.first_name,
      family_name: form.family_name,
      email: form.email,
      position: form.position,
      contact_type: form.contact_type,
      contact_email_types: form.email_types,
      reminder: form.reminder,
      account: form.account,
      reminder_scope: form.reminder_scope,
      countries: form.countries
    };
    //console.log(data);
    return _unwrapAxiosResponse(
      this.httpClient.post<ContactInformation>(
        `${this.contactUrl}?id=${customer_id}`,
        data
      )
    );
  }

  update(form: any, customer_id: number, record_id: number) {
    const data: ContactInformation = {
      id: record_id,
      customer: customer_id,
      first_name: form.first_name,
      family_name: form.family_name,
      email: form.email,
      position: form.position,
      contact_type: form.contact_type,
      contact_email_types: form.email_types,
      reminder: form.reminder,
      account: form.account,
      reminder_scope: form.reminder_scope,
      countries: form.countries
    };
    //console.log(data);

    return _unwrapAxiosResponse(
      this.httpClient.put<ContactInformation>(
        this.contactUrl + record_id + "/",
        data
      )
    );
  }

  delete(records: any, customer_id: any) {
    // perform bulk delete
    // ids are concatenated
    let id = "/?";
    for (const v in records) {
      id += "id=" + records[v].id + "&";
    }

    return _unwrapAxiosResponse(
      this.httpClient.delete<ContactInformation>(
        this.contactUrl + customer_id + id
      )
    );
  }
}
